import React from "react";
//
import PEDNavigation from "../../components/PEDNavigation/PEDNavigation";
// import FooterITP from "../../components/shared-ui/Footer/Footer-ITP";
import FooterPED from "../../components/shared-ui/Footer/Footer-PED";
import BackToTopBtn from "../../components/shared-ui/BackToTopBtn/BackToTopBtn";
import ISIwrapper from "../../components/shared-ui/ISI/ISI-wrapper";
import ISIITP from "../../components/shared-ui/ISI/ISIITP";
import ISIITPinline from "../../components/shared-ui/ISI/ISIITP-inline";

export default function PEDLayout({ children, pageClass }) {
  React.useEffect(() => {
    window.scrollTo(0, 0);
    let location = window.location.pathname;
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      page: {
        path: `${location}`,
        title: "@todo - add title",
        audience: "DTC",
        // environment: "dev",
        // indication: "ITP",
      },
    });
  }, []);
  return (
    <div className="main_content_wrap ped">
      <PEDNavigation />
      <div className={`inner-content-wrap ` + pageClass}>
        {children}
        <ISIITPinline />
      </div>
      <FooterPED />
      <ISIwrapper>
        <ISIITP />
      </ISIwrapper>
      <BackToTopBtn />
    </div>
  );
}
